export const additionalContext = {
    "session": {
      "uuid": {},
      "name": {},
      "email": {},
      "credits": {},
      "ref": {},
      "settings": {},
      "custom_fields": {}
    },
    "thunder": {
      "client": {},
      "constructor": {},
      "find": {},
      "findOne": {},
      "findOneOrInsert": {},
      "modify": {},
      "modifyOrCreate": {},
      "modifyOne": {},
      "updateOne": {}
    },
    "component": {
      "adapter": {},
      "client": {},
      "constructor": {},
      "newByName": {},
      "getByTag": {},
      "new": {},
      "v2": {},
      "v3": {},
      "find": {},
      "findOne": {},
      "get": {},
      "modify": {},
      "update": {},
      "concurrentUpdate": {},
      "create": {},
      "delete": {},
      "aggregate": {},
      "settings": {},
      "saveSettings": {},
      "workflow": {},
      "source": {}
    },
    "integrations": {
      "integrations": {}
    },
    "ratchet": {
      "client": {},
      "constructor": {},
      "query": {}
    },
    "sandbox": {
      "client": {},
      "constructor": {},
      "spark": {}
    },
    "project": {
      "adapter": {}
    },
    "functions": {
      "client": {},
      "constructor": {},
      "run": {}
    },
    "require": {},
    "print": {},
    "axios": {
      "request": {},
      "delete": {},
      "get": {},
      "head": {},
      "options": {},
      "post": {},
      "put": {},
      "patch": {},
      "defaults": {},
      "interceptors": {},
      "Axios": {},
      "create": {},
      "Cancel": {},
      "CancelToken": {},
      "isCancel": {},
      "all": {},
      "spread": {},
      "default": {}
    },
    "moment": {
      "momentProperties": {},
      "parseTwoDigitYear": {},
      "createFromInputFallback": {},
      "ISO_8601": {},
      "RFC_2822": {},
      "updateOffset": {},
      "defaultFormat": {},
      "defaultFormatUtc": {},
      "lang": {},
      "langData": {},
      "version": {},
      "fn": {},
      "min": {},
      "max": {},
      "now": {},
      "utc": {},
      "unix": {},
      "months": {},
      "isDate": {},
      "locale": {},
      "invalid": {},
      "duration": {},
      "isMoment": {},
      "weekdays": {},
      "parseZone": {},
      "localeData": {},
      "isDuration": {},
      "monthsShort": {},
      "weekdaysMin": {},
      "defineLocale": {},
      "updateLocale": {},
      "locales": {},
      "weekdaysShort": {},
      "normalizeUnits": {},
      "relativeTimeRounding": {},
      "relativeTimeThreshold": {},
      "calendarFormat": {},
      "HTML5_FMT": {},
      "tz": {}
    },
    "lodash": {
      "templateSettings": {},
      "after": {},
      "ary": {},
      "assign": {},
      "assignIn": {},
      "assignInWith": {},
      "assignWith": {},
      "at": {},
      "before": {},
      "bind": {},
      "bindAll": {},
      "bindKey": {},
      "castArray": {},
      "chain": {},
      "chunk": {},
      "compact": {},
      "concat": {},
      "cond": {},
      "conforms": {},
      "constant": {},
      "countBy": {},
      "create": {},
      "curry": {},
      "curryRight": {},
      "debounce": {},
      "defaults": {},
      "defaultsDeep": {},
      "defer": {},
      "delay": {},
      "difference": {},
      "differenceBy": {},
      "differenceWith": {},
      "drop": {},
      "dropRight": {},
      "dropRightWhile": {},
      "dropWhile": {},
      "fill": {},
      "filter": {},
      "flatMap": {},
      "flatMapDeep": {},
      "flatMapDepth": {},
      "flatten": {},
      "flattenDeep": {},
      "flattenDepth": {},
      "flip": {},
      "flow": {},
      "flowRight": {},
      "fromPairs": {},
      "functions": {},
      "functionsIn": {},
      "groupBy": {},
      "initial": {},
      "intersection": {},
      "intersectionBy": {},
      "intersectionWith": {},
      "invert": {},
      "invertBy": {},
      "invokeMap": {},
      "iteratee": {},
      "keyBy": {},
      "keys": {},
      "keysIn": {},
      "map": {},
      "mapKeys": {},
      "mapValues": {},
      "matches": {},
      "matchesProperty": {},
      "memoize": {},
      "merge": {},
      "mergeWith": {},
      "method": {},
      "methodOf": {},
      "mixin": {},
      "negate": {},
      "nthArg": {},
      "omit": {},
      "omitBy": {},
      "once": {},
      "orderBy": {},
      "over": {},
      "overArgs": {},
      "overEvery": {},
      "overSome": {},
      "partial": {},
      "partialRight": {},
      "partition": {},
      "pick": {},
      "pickBy": {},
      "property": {},
      "propertyOf": {},
      "pull": {},
      "pullAll": {},
      "pullAllBy": {},
      "pullAllWith": {},
      "pullAt": {},
      "range": {},
      "rangeRight": {},
      "rearg": {},
      "reject": {},
      "remove": {},
      "rest": {},
      "reverse": {},
      "sampleSize": {},
      "set": {},
      "setWith": {},
      "shuffle": {},
      "slice": {},
      "sortBy": {},
      "sortedUniq": {},
      "sortedUniqBy": {},
      "split": {},
      "spread": {},
      "tail": {},
      "take": {},
      "takeRight": {},
      "takeRightWhile": {},
      "takeWhile": {},
      "tap": {},
      "throttle": {},
      "thru": {},
      "toArray": {},
      "toPairs": {},
      "toPairsIn": {},
      "toPath": {},
      "toPlainObject": {},
      "transform": {},
      "unary": {},
      "union": {},
      "unionBy": {},
      "unionWith": {},
      "uniq": {},
      "uniqBy": {},
      "uniqWith": {},
      "unset": {},
      "unzip": {},
      "unzipWith": {},
      "update": {},
      "updateWith": {},
      "values": {},
      "valuesIn": {},
      "without": {},
      "words": {},
      "wrap": {},
      "xor": {},
      "xorBy": {},
      "xorWith": {},
      "zip": {},
      "zipObject": {},
      "zipObjectDeep": {},
      "zipWith": {},
      "entries": {},
      "entriesIn": {},
      "extend": {},
      "extendWith": {},
      "add": {},
      "attempt": {},
      "camelCase": {},
      "capitalize": {},
      "ceil": {},
      "clamp": {},
      "clone": {},
      "cloneDeep": {},
      "cloneDeepWith": {},
      "cloneWith": {},
      "conformsTo": {},
      "deburr": {},
      "defaultTo": {},
      "divide": {},
      "endsWith": {},
      "eq": {},
      "escape": {},
      "escapeRegExp": {},
      "every": {},
      "find": {},
      "findIndex": {},
      "findKey": {},
      "findLast": {},
      "findLastIndex": {},
      "findLastKey": {},
      "floor": {},
      "forEach": {},
      "forEachRight": {},
      "forIn": {},
      "forInRight": {},
      "forOwn": {},
      "forOwnRight": {},
      "get": {},
      "gt": {},
      "gte": {},
      "has": {},
      "hasIn": {},
      "head": {},
      "identity": {},
      "includes": {},
      "indexOf": {},
      "inRange": {},
      "invoke": {},
      "isArguments": {},
      "isArray": {},
      "isArrayBuffer": {},
      "isArrayLike": {},
      "isArrayLikeObject": {},
      "isBoolean": {},
      "isBuffer": {},
      "isDate": {},
      "isElement": {},
      "isEmpty": {},
      "isEqual": {},
      "isEqualWith": {},
      "isError": {},
      "isFinite": {},
      "isFunction": {},
      "isInteger": {},
      "isLength": {},
      "isMap": {},
      "isMatch": {},
      "isMatchWith": {},
      "isNaN": {},
      "isNative": {},
      "isNil": {},
      "isNull": {},
      "isNumber": {},
      "isObject": {},
      "isObjectLike": {},
      "isPlainObject": {},
      "isRegExp": {},
      "isSafeInteger": {},
      "isSet": {},
      "isString": {},
      "isSymbol": {},
      "isTypedArray": {},
      "isUndefined": {},
      "isWeakMap": {},
      "isWeakSet": {},
      "join": {},
      "kebabCase": {},
      "last": {},
      "lastIndexOf": {},
      "lowerCase": {},
      "lowerFirst": {},
      "lt": {},
      "lte": {},
      "max": {},
      "maxBy": {},
      "mean": {},
      "meanBy": {},
      "min": {},
      "minBy": {},
      "stubArray": {},
      "stubFalse": {},
      "stubObject": {},
      "stubString": {},
      "stubTrue": {},
      "multiply": {},
      "nth": {},
      "noConflict": {},
      "noop": {},
      "now": {},
      "pad": {},
      "padEnd": {},
      "padStart": {},
      "parseInt": {},
      "random": {},
      "reduce": {},
      "reduceRight": {},
      "repeat": {},
      "replace": {},
      "result": {},
      "round": {},
      "runInContext": {},
      "sample": {},
      "size": {},
      "snakeCase": {},
      "some": {},
      "sortedIndex": {},
      "sortedIndexBy": {},
      "sortedIndexOf": {},
      "sortedLastIndex": {},
      "sortedLastIndexBy": {},
      "sortedLastIndexOf": {},
      "startCase": {},
      "startsWith": {},
      "subtract": {},
      "sum": {},
      "sumBy": {},
      "template": {},
      "times": {},
      "toFinite": {},
      "toInteger": {},
      "toLength": {},
      "toLower": {},
      "toNumber": {},
      "toSafeInteger": {},
      "toString": {},
      "toUpper": {},
      "trim": {},
      "trimEnd": {},
      "trimStart": {},
      "truncate": {},
      "unescape": {},
      "uniqueId": {},
      "upperCase": {},
      "upperFirst": {},
      "each": {},
      "eachRight": {},
      "first": {},
      "VERSION": {}
    },
    "log": {
      "info": {},
      "error": {}
    },
    "util": {
      "dateToUserTimezone": {},
      "dateToTimezone": {},
      "dateToUserTimezoneAsTime": {},
      "dateToTimezoneAsTime": {}
    },
    "app": {
      "showLoadingPopup": {},
      "store": {},
      "find": {},
      "openWindow": {},
      "getEnv": {},
      "notify": {},
      "interval": {},
      "audio": {},
      "registerComponent": {},
      "eval": {},
      "storage": {}
    },
    "user": {
      "roles": {},
      "can": {}
    },
    "event": {
      "listen": {}
    },
    "loader": {
      "loadSVG": {}
    },
    "file": {
      "readAsDataUrl": {}
    },
    "eventbus": {
      "host": {},
      "subscribers": {},
      "env": {},
      "platformClient": {},
      "onerror": {},
      "onclose": {}
    },
    "voyager": {
      "call": {}
    },
    "exports": {}
  }


  export const customCompleteList = [
    {
        "text": "constructor",
        "type": "keyword",
        "displayText": " constructor - Resource",
        "detail": "Resource"
    },
    {
        "text": "find",
        "type": "keyword",
        "displayText": " find - Resource",
        "detail": "Resource"
    },
    {
        "text": "findOne",
        "type": "keyword",
        "displayText": " findOne - Resource",
        "detail": "Resource"
    },
    {
        "text": "findOneOrInsert",
        "type": "keyword",
        "displayText": " findOneOrInsert - Resource",
        "detail": "Resource"
    },
    {
        "text": "modify",
        "type": "keyword",
        "displayText": " modify - Resource",
        "detail": "Resource"
    },
    {
        "text": "modifyOrCreate",
        "type": "keyword",
        "displayText": " modifyOrCreate - Resource",
        "detail": "Resource"
    },
    {
        "text": "modifyOne",
        "type": "keyword",
        "displayText": " modifyOne - Resource",
        "detail": "Resource"
    },
    {
        "text": "updateOne",
        "type": "keyword",
        "displayText": " updateOne - Resource",
        "detail": "Resource"
    },
    {
        "text": "constructor",
        "type": "keyword",
        "displayText": " constructor - ComponentV2",
        "detail": "ComponentV2"
    },
    {
        "text": "newByName",
        "type": "keyword",
        "displayText": " newByName - ComponentV2",
        "detail": "ComponentV2"
    },
    {
        "text": "getByTag",
        "type": "keyword",
        "displayText": " getByTag - ComponentV2",
        "detail": "ComponentV2"
    },
    {
        "text": "new",
        "type": "keyword",
        "displayText": " new - ComponentV2",
        "detail": "ComponentV2"
    },
    {
        "text": "v2",
        "type": "keyword",
        "displayText": " v2 - ComponentV2",
        "detail": "ComponentV2"
    },
    {
        "text": "v3",
        "type": "keyword",
        "displayText": " v3 - ComponentV2",
        "detail": "ComponentV2"
    },
    {
        "text": "find",
        "type": "keyword",
        "displayText": " find - ComponentV2",
        "detail": "ComponentV2"
    },
    {
        "text": "findOne",
        "type": "keyword",
        "displayText": " findOne - ComponentV2",
        "detail": "ComponentV2"
    },
    {
        "text": "get",
        "type": "keyword",
        "displayText": " get - ComponentV2",
        "detail": "ComponentV2"
    },
    {
        "text": "modify",
        "type": "keyword",
        "displayText": " modify - ComponentV2",
        "detail": "ComponentV2"
    },
    {
        "text": "update",
        "type": "keyword",
        "displayText": " update - ComponentV2",
        "detail": "ComponentV2"
    },
    {
        "text": "concurrentUpdate",
        "type": "keyword",
        "displayText": " concurrentUpdate - ComponentV2",
        "detail": "ComponentV2"
    },
    {
        "text": "create",
        "type": "keyword",
        "displayText": " create - ComponentV2",
        "detail": "ComponentV2"
    },
    {
        "text": "delete",
        "type": "keyword",
        "displayText": " delete - ComponentV2",
        "detail": "ComponentV2"
    },
    {
        "text": "aggregate",
        "type": "keyword",
        "displayText": " aggregate - ComponentV2",
        "detail": "ComponentV2"
    },
    {
        "text": "settings",
        "type": "keyword",
        "displayText": " settings - ComponentV2",
        "detail": "ComponentV2"
    },
    {
        "text": "saveSettings",
        "type": "keyword",
        "displayText": " saveSettings - ComponentV2",
        "detail": "ComponentV2"
    },
    {
        "text": "workflow",
        "type": "keyword",
        "displayText": " workflow - ComponentV2",
        "detail": "ComponentV2"
    },
    {
        "text": "constructor",
        "type": "keyword",
        "displayText": " constructor - Ratchet",
        "detail": "Ratchet"
    },
    {
        "text": "query",
        "type": "keyword",
        "displayText": " query - Ratchet",
        "detail": "Ratchet"
    },
    {
        "text": "constructor",
        "type": "keyword",
        "displayText": " constructor - Sandbox",
        "detail": "Sandbox"
    },
    {
        "text": "spark",
        "type": "keyword",
        "displayText": " spark - Sandbox",
        "detail": "Sandbox"
    },
    {
        "text": "constructor",
        "type": "keyword",
        "displayText": " constructor - Functions",
        "detail": "Functions"
    },
    {
        "text": "run",
        "type": "keyword",
        "displayText": " run - Functions",
        "detail": "Functions"
    },
    {
        "text": "constructor",
        "type": "keyword",
        "displayText": " constructor - Event",
        "detail": "Event"
    },
    {
        "text": "auth",
        "type": "keyword",
        "displayText": " auth - Event",
        "detail": "Event"
    },
    {
        "text": "connect",
        "type": "keyword",
        "displayText": " connect - Event",
        "detail": "Event"
    },
    {
        "text": "client",
        "type": "keyword",
        "displayText": " client - Event",
        "detail": "Event"
    },
    {
        "text": "subscribe",
        "type": "keyword",
        "displayText": " subscribe - Event",
        "detail": "Event"
    },
    {
        "text": "publish",
        "type": "keyword",
        "displayText": " publish - Event",
        "detail": "Event"
    },
    {
        "text": "close",
        "type": "keyword",
        "displayText": " close - Event",
        "detail": "Event"
    },
    {
        "text": "onclose",
        "type": "keyword",
        "displayText": " onclose - Event",
        "detail": "Event"
    },
    {
        "text": "onerror",
        "type": "keyword",
        "displayText": " onerror - Event",
        "detail": "Event"
    }
]